module.exports = __webpack_public_path__ + "img/link.9f550af4.png";